module.exports = __webpack_public_path__ + "img/phone.74476efb.png";